import { render, staticRenderFns } from "./DataContainer.vue?vue&type=template&id=1166eeee&scoped=true"
import script from "./DataContainer.vue?vue&type=script&lang=js"
export * from "./DataContainer.vue?vue&type=script&lang=js"
import style0 from "./DataContainer.vue?vue&type=style&index=0&id=1166eeee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166eeee",
  null
  
)

export default component.exports